<template origin="center center">
  <v-container id="offers_view" fluid class="pt-3">
    <v-row class="pl-4 pr-7 pt-3">
      <v-col cols="auto" class="pt-2">
        <div class="breadcrumb pa-1 ml-3">
          <Breadcrumbs />
        </div>
      </v-col>
    </v-row>
    <v-row :class="!$vuetify.breakpoint.xs ? 'pl-7 pr-7' : ''">
    </v-row>
    <v-row :class="!$vuetify.breakpoint.xs ? 'pl-7 pr-7' : ''">
      <v-col cols="12">
        <Form />
      </v-col>
    </v-row>
    <v-row :class="!$vuetify.breakpoint.xs ? 'pl-7 pr-7' : ''">
      <v-col cols="12">
        <Skeleton v-if="loading" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: this.$t("views.trips.create_trip.title"), // Traducción del título
    };
  },
  components: {
    Breadcrumbs: () =>
      import(/* webpackChunkName: "BreadcrumbsCreate" */ "@/components/views/Trip/Create/breadcrumb/BreadCrumb.vue"),
    Form: () =>
      import(/* webpackChunkName: "FormCreate" */ "@/components/views/Trip/Create/Form.vue"),
    Skeleton: () =>
      import(/* webpackChunkName: "SkeletonCreate" */ "@/components/views/Trip/Skeleton.vue"),
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>


<style scoped>
h1 {
  color: #0b0045;
}

.breadcrumb {
  background-color: #fff;
  border-radius: 8px;
}
</style>